<template>
    <div class="star-wrap">
        <img v-for="i in prop.count"
             :src="require(i <= val ? '@/assets/icons/star-s.png' : '@/assets/icons/star.png')"/>
    </div>
</template>
<script setup>
    import index from '../panel/index.vue';
    import buyList from '../panel/preBook.vue';

    import {ref, reactive} from 'vue';
    let prop = defineProps({
        count: {type: Number, default: 5},
        val: {type: Number, default: 0},
    });
    let data = reactive({})

</script>
<style lang="scss">
.star-wrap {
    display: inline-block;

    img {
        height: 1.2em;

        & + img {
            margin-left: .5em;
        }
    }
}
</style>
